export const LockMark = ({ className = "h-8 w-8", color = "#F26D5A" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g fill="none" stroke={color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 30a20 20 0 0 1 34-12" />
      <path d="M46 10v8h-8" />
      <path d="M52 34a20 20 0 0 1-34 12" />
      <path d="M18 54v-8h8" />
      <path d="M25 30v-4a7 7 0 0 1 14 0v4" />
      <rect x="21" y="30" width="22" height="16" rx="3" />
    </g>
    <circle cx="32" cy="37" r="2.6" fill={color} />
    <path d="M32 38v4" stroke={color} strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ dark = false, tagline = true, size = "md" }) => {
  const txt = size === "lg" ? "text-4xl sm:text-5xl" : "text-xl sm:text-2xl";
  const mark = size === "lg" ? "h-12 w-12 sm:h-14 sm:w-14" : "h-7 w-7 sm:h-8 sm:w-8";
  return (
    <span className="inline-flex flex-col items-start leading-none" data-testid="brand-logo">
      <span className="inline-flex items-center gap-1.5 sm:gap-2">
        <span className={`font-stencil ${txt} ${dark ? "text-[#C9C0B6]" : "text-[#A69B8F]"}`}>FES</span>
        <LockMark className={`${mark} logo-spin`} />
        <span className={`font-stencil ${txt} text-espai`}>ESPAI</span>
      </span>
      {tagline && (
        <span className={`mt-1 text-[10px] font-bold tracking-[0.32em] ${dark ? "text-[#C9C0B6]" : "text-[#7a7065]"}`}>
          SELF STORAGE · OLOT
        </span>
      )}
    </span>
  );
};
